import React, {useEffect} from 'react'
import {IconButton, Popover, Checkbox, Grid, Typography} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import './FilterSelectedValues.scss'
export default function FilterSelectedValues({
  options,
  handleClickSelectedValueOption,
  handleCloseValueOption,
  value,
  values,
  handleApplyFilter,
  setSelectedFilters,
}) {
  const isSelected = id => {
    if (value && (value?.field_id === id || value?.id === id)) {
      return true
    }
    return false
  }
  const handleClearAllOption = () => {
    values = []
    setSelectedFilters(values)
  }

  return (
    <div
      className="c-res-mod ap-list ap-scrollbar"
      style={{maxHeight: 200, padding: '17px', width: '200px'}}
    >
      <Grid row xs={12}>
        <Grid xs={9}>
          <Typography className="ap-typography--sm"> Applied Filters </Typography>
        </Grid>
        <Grid xs={3}>
          <Button className="clear" onClick={e => handleClearAllOption(e)}>
            {' '}
            Clear{' '}
          </Button>
        </Grid>
      </Grid>
      <div className="ap-list__wrapper" style={{padding: '9px 8px'}}>
        {values.map((o, i) => (
          <>
            <div
              key={i}
              className={`ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option c-pop-selected-field-toggle
              ${isSelected(o.id) ? 'selected_filter_selected_value' : ''}`}
              style={{cursor: 'pointer'}}
            >
              <Grid
                item
                xs={10}
                onClick={e => handleClickSelectedValueOption(e, o)}
              >{`(${o.value.length}) ${o.field_name}`}</Grid>
              <Grid item xs={2}>
                <IconButton
                  type="submit"
                  className=""
                  underline={false}
                  aria-label="search"
                  style={{padding: 0, color: `${isSelected(o.id) ? '#003099' : ''} `}}
                  onClick={e => handleCloseValueOption(e, o)}
                  disableRipple
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </div>
            <div className="apply-button">
              <Button
                variant="contained"
                color="primary"
                style={{backgroundColor: '#3473ff'}}
                onClick={handleApplyFilter}
              >
                Apply
              </Button>
            </div>
          </>
        ))}
      </div>
    </div>
  )
}
